export const I18N_LOCALE_KEY = "I18N_LOCALE";
export const I18N_REGION_KEY = "I18N_REGION";

declare global {
  interface Window {
    [I18N_LOCALE_KEY]: string;
    [I18N_REGION_KEY]: string;
    __reactRouterManifest?: {
      version: string;
    };
  }
}
